export default __webpack_public_path__ + "static/media/boddyssey_trailer_jonas_bienz_website_still.290f3488.jpg";